import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'

import { getDdRumConfig } from 'app/services/core/config.service'

export default function useDdRum() {
  useEffect(() => {
    datadogRum.init({ ...getDdRumConfig(), trackUserInteractions: false })
  }, [])
}
